var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('share-comp',{attrs:{"type":_vm.type,"orderid":_vm.orderid,"num":_vm.num,"sendDesc":_vm.sendDesc},on:{"close":function($event){return _vm.closeShare()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }